import React, { useEffect } from "react";
import { Button, PageHeader, Descriptions } from "antd";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import { communityStore } from "../../store/community/CommunityStore";
import { observer } from "mobx-react";
import { communitiesStore, CommunityStatusNames } from "../../store/community/CommunitiesStore";
import { EditCommunityDlg } from "./EditCommunityDlg";
import { Store } from "../../store/Store";
import { Organizations2 } from "../organization/Organizations2";

export const Community = observer(() => {
  const store = communityStore;
  let { id } = useParams<any>();

  useEffect(() => {
    store.onLoad(id);
    Store.orgsStore.loadData(id);
  }, [id]);

  const onOk = () => {
    setTimeout(() => {
      store.refresh();
    }, 3000);
  };

  return (
    <div>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={store.data.name + "@" + store.data?.state}
        extra={[
          Store.isDivision ? null : (
            <Button size="small" key="3" onClick={() => communitiesStore.edit.edit(id)}>
              Edit
            </Button>
          ),
        ]}
      >
        <div className="content" style={{ display: "flex" }}>
          <div className="main">
            <Descriptions size="small" column={3}>
              <Descriptions.Item label="Division">{store.data.division?.name}</Descriptions.Item>
              <Descriptions.Item label="Status">{CommunityStatusNames[store.data.status]}</Descriptions.Item>
              <Descriptions.Item label="Creation Time">
                {moment(store.data?.createDate).format("YYYY-MM-DD HH:mm:ss")}
              </Descriptions.Item>
              <Descriptions.Item label="Description" span={1}>
                {store.data?.description}
              </Descriptions.Item>
              <Descriptions.Item label="Price Pack" span={1}>
                {store.data?.pricePack}
              </Descriptions.Item>
            </Descriptions>
          </div>
          <div className="extra">
            <div
              style={{
                display: "flex",
                width: "max-content",
                justifyContent: "flex-end",
              }}
            >
              {/* <Statistic title="Status" value="Pending" style={{ marginRight: 32 }} /> */}
              {/* <Statistic title="Historic" prefix="$" value={fundraiser?.historic} style={{ marginRight: 32 }} />
              <Statistic title="Suggested" prefix="$" value={fundraiser?.suggested} style={{ marginRight: 32 }} />
              <Statistic title="Target" prefix="$" value={fundraiser?.target} style={{ marginRight: 32 }} /> */}
            </div>
          </div>
        </div>
      </PageHeader>

      <div style={{ padding: 16 }}>
        <Organizations2 />
      </div>

      {communitiesStore.edit.visible && <EditCommunityDlg onOk={onOk} />}
    </div>
  );
});
